import { withChartLayout } from 'components/common';
import PainAssessment from 'components/features/chart/system-assessment/pain-assessment/PainAssessment';

const PainAssessmentPage = withChartLayout('Pain Assessment')(PainAssessment);
export default PainAssessmentPage;
